export default {
  destinations: [
    { destinationId: 'Vegetables',map: 'map1',bestTime: 0,medal: '',baseType: 'plate' },
    { destinationId: 'Fruit',map: 'map2',bestTime: 0,medal: '',baseType: 'plate' },
    { destinationId: 'Dairy',map: 'map3',bestTime: 0,medal: '',baseType: 'plate' },
    { destinationId: 'Protein',map: 'map4',bestTime: 0,medal: '',baseType: 'plate' },
    { destinationId: 'Grains',map: 'map5',bestTime: 0,medal: '',baseType: 'plate' },
    { destinationId: 'Physical Activity',map: 'map6',bestTime: 0,medal: '',baseType: '' }
  ]
};